/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { TicketType } from './TicketType';

export enum TicketDropdownTypes {
	CONTRAINT_ASSIGNED = 'constraint_assigned',
	CONSTRAINT_ACCEPTED = 'constraint_accepted',
}

export type CombinedTicketTypes = TicketType | TicketDropdownTypes;
